let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("25TW9")).then(() => parcelRequire('ab4oe'));